import styled from 'styled-components';

const WarpperFullScreen = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: auto;
`;

export default WarpperFullScreen;
